import React from 'react'
import HackerLeader from '../../components/BugBounty/HackerLeaderboard'

const HackersLeaderBoard = () => {
  return (
    <div>
        <HackerLeader></HackerLeader>
    </div>
  )
}

export default HackersLeaderBoard